import React from 'react';
import ReactMarkdown from 'react-markdown';

export default ({ content }) => (
    <div className="endpoint-description mt-3 pb-1">
        <ReactMarkdown>{content}</ReactMarkdown>
    </div>
);
